import axios from '../utils/axios';
import { requests } from '../utils/urls';
import { formDataCreator, urlencodedDataCreator } from '../utils/functions';

const getShopById = async (shopId) => {
  try {
    const response = await axios.get(requests.management.shop.getById(shopId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const shopViewOne = async (shopId) => {
  try {
    const response = await axios.get(requests.management.shop.getOneById(shopId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const createShop = async (values) => {
  try {
    const response = await axios.post(requests.management.shop.create, values, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const editShop = async (shopId, values) => {
  const data = urlencodedDataCreator(values);
  try {
    const response = await axios.patch(requests.management.shop.edit(shopId), data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const setShopWage = async (shopId, values) => {
  try {
    const response = await axios.post(requests.management.shop.setWage(shopId), values);
    return response;
  } catch (e) {
    return e.response;
  }
};

const editShopLogo = async (shopId, values) => {
  const data = formDataCreator(values);
  try {
    const response = await axios.post(requests.management.shopSettings.editLogo(shopId), data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: { _method: 'patch' },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const editShopHeader = async (shopId, values) => {
  const data = formDataCreator(values);
  try {
    const response = await axios.post(requests.management.shopSettings.editHeader(shopId), data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: { _method: 'patch' },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const editShopAddress = async (shopId, addressId, values) => {
  try {
    const response = await axios.patch(requests.management.shop.editAddress(shopId, addressId), values);
    return response;
  } catch (e) {
    return e.response;
  }
};

const syncShopCallNumbers = async (shopId, values) => {
  try {
    const response = await axios.patch(requests.management.shopSettings.syncCallNumbers(shopId), values, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const syncShopCategories = async (shopId, values) => {
  try {
    const response = await axios.patch(requests.management.shopSettings.syncShopCategories(shopId), values, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const syncShopMealTags = async (shopId, values) => {
  try {
    const response = await axios.patch(requests.management.shopSettings.syncShopMealTags(shopId), values, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const getShopGeofence = async (shopId) => {
  try {
    const response = await axios.get(requests.management.shop.getShopGeofence(shopId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const deleteShopGeofence = async (shopId, geoId) => {
  try {
    const response = await axios.delete(requests.management.shop.deleteShopGeofence(shopId, geoId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const viewShopGeofence = async (shopId, geoId) => {
  try {
    const response = await axios.get(requests.management.shop.viewShopGeofence(shopId, geoId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const getAllShops = async (values) => {
  try {
    const response = await axios.get(
      `${requests.management.shop.getAll}?page=${values.page}&paginate=${values.paginate}&${
        values.name && values.name === 'all' ? '' : `name=${values.name}&`
      }${values.status && values.status !== 'all' ? `status=${values.status}` : ''}`
    );

    return response;
  } catch (e) {
    return e.response;
  }
};

const getAllShopUsers = async (shopId, values) => {
  try {
    return await axios.get(
      `${requests.management.shop.users.getAll(shopId)}?page=${values.page}&paginate=${values.paginate}&${
        values.filter_value && `filter_value=${values.filter_value}`
      }`
    );
  } catch (e) {
    return e.response;
  }
};
const getAllShopRoles = async (shopId) => {
  try {
    const {
      data: {
        data: { roles },
      },
    } = await axios.get(requests.management.role.getAllShopRoles(shopId));
    return roles;
  } catch (e) {
    throw error(e.response);
  }
};
const deleteShopRole = async (shopId, roleId) => {
  try {
    await axios.delete(requests.management.role.deleteShopRole(shopId, roleId));
  } catch (e) {
    throw error(e.response);
  }
};

const getShopTransaction = async (values, shopId) => {
  try {
    const response = await axios.get(
      `${requests.management.shop.getAllTransaction(shopId)}?page=${values.page}&paginate=${values.paginate}&${
        values.type && values.type == 'all' ? '' : `type=${values.type}&`
      }${values.reason && values.reason == 'all' ? '' : `reason=${values.reason}&`}${
        values.start_date && `start_date=${values.start_date}&`
      }${values.end_date && `end_date=${values.end_date}`}`
    );

    return response;
  } catch (e) {
    return e.response;
  }
};

const shopLiteSearch = async () => {
  try {
    return await axios.get(requests.management.shop.liteSearch);
  } catch (e) {
    return e.response;
  }
};

const shopNoticeCallNumbers = async (shopId) => {
  try {
    return await axios.get(requests.management.shopSettings.noticeCallNumbers(shopId));
  } catch (e) {
    return e.response;
  }
};

const shopUsersCallNumbers = async (shopId) => {
  try {
    return await axios.get(requests.management.shopSettings.usersCallNumbers(shopId));
  } catch (e) {
    return e.response;
  }
};

const syncNoticeCallNumbers = async (shopId, values) => {
  try {
    const response = await axios.patch(requests.management.shopSettings.syncNoticeCallNumbers(shopId), values, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const getCheckoutCallNumbers = async (shopId) => {
  try {
    return await axios.get(requests.management.shopSettings.getCheckoutCallNumbers(shopId));
  } catch (e) {
    return e.response;
  }
};

const syncCheckoutCallNumbers = async (shopId, values) => {
  try {
    const response = await axios.patch(requests.management.shopSettings.syncCheckoutCallNumbers(shopId), values, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const usersBankAccounts = async (shopId) => {
  try {
    return await axios.get(requests.management.shop.usersBankAccounts(shopId));
  } catch (e) {
    return e.response;
  }
};

const bankAccounts = async (shopId) => {
  try {
    return await axios.get(requests.management.shop.bankAccounts(shopId));
  } catch (e) {
    return e.response;
  }
};

const addBankAccount = async (shopId, values) => {
  try {
    const response = await axios.post(requests.management.shop.addBankAccount(shopId), values);
    return response;
  } catch (e) {
    return e.response;
  }
};

const reviewedByShop = async (shopId, values) => {
  try {
    const response = await axios.patch(requests.management.shop.reviewed(shopId), values);
    return response;
  } catch (e) {
    return e.response;
  }
};

const shopInvioce = async (shopId, values, receivedHID) => {
  try {
    const response = await axios.get(
      `${requests.management.shop.shopInvioce(shopId)}?page=${values.page}&paginate=${values.paginate}&${
        (receivedHID && `id=${receivedHID}&`) || (values.id && `id=${values.id}&`)
      }${values.username && `username=${values.username}&`}${
        values.call_number && `call_number=${values.call_number}&`
      }${values.payment_method && values.payment_method == 'all' ? '' : `payment_method=${values.payment_method}&`}${
        values.is_paid && values.is_paid == 'all' ? '' : `is_paid=${values.is_paid}&`
      }${values.status && values.status.map((item) => `status[]=${item.id}&`).join('')}${
        values.start_date && `start_date=${values.start_date}&`
      }${values.end_date && `end_date=${values.end_date}&`}`
    );
    return response;
  } catch (e) {
    return e.response;
  }
};

const shopInvioceExcel = async (shopId, values) => {
  try {
    const response = await axios.get(
      `${requests.management.shop.shopInvioceExcel(shopId)}?page=${values.page}&paginate=${values.paginate}&${
        values.id && `id=${values.id}&`
      }${values.username && `username=${values.username}&`}${
        values.call_number && `call_number=${values.call_number}&`
      }${values.payment_method && values.payment_method == 'all' ? '' : `payment_method=${values.payment_method}&`}${
        values.is_paid && values.is_paid == 'all' ? '' : `is_paid=${values.is_paid}&`
      }${values.status && values.status.map((item) => `status[]=${item.id}&`).join('')}${
        values.start_date && `start_date=${values.start_date}&`
      }${values.end_date && `end_date=${values.end_date}&`}`,
      {
        responseType: 'blob',
      }
    );
    return response;
  } catch (e) {
    return e.response;
  }
};

const orderListShopInvoice = async (shopId, invoiceId) => {
  try {
    const response = await axios.get(requests.management.shop.orderList(shopId, invoiceId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const showShopInvoice = async (shopId, invoiceId) => {
  try {
    const response = await axios.get(requests.management.shop.showShopInvoice(shopId, invoiceId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const acceptStatus = async (shopId, invoiceId) => {
  try {
    const response = await axios.patch(requests.management.shop.acceptStatus(shopId, invoiceId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const shopDiscountCourier = async (shopId, values) => {
  try {
    const response = await axios.post(requests.management.shop.shopDiscountCourier(shopId), values);
    return response;
  } catch (e) {
    return e.response;
  }
};

const shopDiscountCourierFee = async (shopId, values) => {
  try {
    const response = await axios.post(requests.management.shop.shopDiscountCourierFee(shopId), values);
    return response;
  } catch (e) {
    return e.response;
  }
};

const getshopDiscountCourier = async (shopId) => {
  try {
    const response = await axios.get(requests.management.shop.getShopDiscountCourier(shopId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const changeGeofenceActiveState = async (shopId, geofenceId, values) => {
  try {
    return await axios.patch(requests.management.shop.changeStatusGeofance(shopId, geofenceId), values);
  } catch (e) {
    return e.response;
  }
};

const changeShopStatus = async (shopId, values) => {
  try {
    return await axios.patch(requests.management.shop.changeStatusShop(shopId), values);
  } catch (e) {
    return e.response;
  }
};

const AnnouncingClosureShop = async (shopId, values, selectedRadio) => {
  try {
    return await axios.post(requests.management.shop.AnnouncingClosureShop(shopId), values, {
      params: {
        selectedRadio: selectedRadio,
      },
    });
  } catch (e) {
    return e.response;
  }
};

const isHolidyOpen = async (shopId) => {
  try {
    return await axios.patch(requests.management.shop.isHolidyOpen(shopId));
  } catch (e) {
    return e.response;
  }
};

const getShopUserBlock = async (shopId, values) => {
  try {
    return await axios.get(
      `${requests.management.shop.shopUserBlock.getAll(shopId)}?page=${values.page}&paginate=${values.paginate}&${
        values.username && `username=${values.username}`
      }`
    );
  } catch (e) {
    return e.response;
  }
};

const blockUser = async (shopId, values) => {
  try {
    return await axios.post(requests.management.shop.shopUserBlock.block(shopId), values);
  } catch (e) {
    return e.response;
  }
};

const unBlockShopUser = async (shopId, userId) => {
  try {
    const response = await axios.delete(requests.management.shop.shopUserBlock.unBlockUser(shopId, userId));
    return response;
  } catch (e) {
    return e.response;
  }
};
const shopSearch = async (shopName) => {
  try {
    const response = await axios.get(requests.management.shop.shopSeacrch(shopName));
    return response;
  } catch (e) {
    return e.response;
  }
};

const syncShopSettlementCategories = async (shopId, values) => {
  try {
    const response = await axios.patch(requests.management.shopSettings.syncShopSettlementCategories(shopId), values);
    return response;
  } catch (e) {
    return e.response;
  }
};

const shopWage = async (shopId) => {
  try {
    const response = await axios.get(requests.management.shop.shopWage(shopId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const setWage = async (shopId, values) => {
  try {
    return await axios.post(requests.management.shop.setWage(shopId), values);
  } catch (e) {
    return e.response;
  }
};

const getDiscountShop = async (shopId) => {
  try {
    return await axios.get(requests.management.shop.shopDiscount(shopId));
  } catch (e) {
    return e.response;
  }
};

const setDiscountShop = async (shopId, values) => {
  try {
    return await axios.post(requests.management.shop.setDiscountShop(shopId), values);
  } catch (e) {
    return e.response;
  }
};

const allShopDiscountCode = async (shopId, values) => {
  try {
    const response = await axios.get(
      `${requests.management.shop.allShopDiscountCode(shopId)}?page=${values.page}&paginate=${values.paginate}&${
        values.code && `code=${values.code}&`
      }`
    );
    return response;
  } catch (e) {
    return e.response;
  }
};

const deleteDiscountCodeShop = async (shopId, discountcodeId) => {
  try {
    const response = await axios.delete(requests.management.shop.deleteDiscountCodeShop(shopId, discountcodeId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const createDiscountCodeShop = async (shopId, values) => {
  try {
    return await axios.post(requests.management.shop.createDiscountCodeShop(shopId), values);
  } catch (e) {
    return e.response;
  }
};

const ShopMassGroupEdit = async (shopId, values) => {
  try {
    return await axios.patch(requests.management.shop.shopEditGeofance(shopId), values);
  } catch (e) {
    return e.response;
  }
};

const deleteAddressShop = async (shopId, addressId) => {
  try {
    const response = await axios.delete(requests.management.shop.deleteAddress(shopId, addressId));
    return response;
  } catch (e) {
    return e.response;
  }
};

const createAddressShop = async (shopId, values) => {
  try {
    return await axios.post(requests.management.shop.createAddress(shopId), values);
  } catch (e) {
    return e.response;
  }
};

const deleteShopUser = async (shopId, values) => {
  try {
    return await axios.patch(requests.management.shop.deleteShopUser(shopId), {
      username: values,
    });
  } catch (e) {
    return e.response;
  }
};

const sendPanelLinkViaSms = async (shopId) => {
  try {
    return await axios.post(requests.management.shop.sendPanelLinkViaSms(shopId));
  } catch (e) {
    return e.response;
  }
};

const getCourierSelect = async (shopId) => {
  try {
    return await axios.get(requests.management.shop.getCourierSelect(shopId));
  } catch (e) {
    return e.response;
  }
};

const syncCouriers = async (shopId, values) => {
  try {
    return await axios.patch(requests.management.shop.syncCouriers(shopId), values, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  } catch (e) {
    return e.response;
  }
};

const deleteShop = async (id) => {
  try {
    const response = await axios.delete(requests.management.shop.delete(id));
    return response;
  } catch (e) {
    return e.response;
  }
};

const getClosureShops = async (values) => {
  try {
    const response = await axios.get(requests.management.shop.getAll, {
      params: {
        page: values.page,
        paginate: values.paginate,
        filter_by_holidays: values.filter_by_holidays,
        ...(values.name && values.name !== 'all' ? { name: values.name } : {}),
        status: values.status,
      },
    });
    return response;
  } catch (e) {
    return e.response;
  }
};

const bestSellingItemsShop = async (shopId, values) => {
  try {
    const response = await axios.get(
      `${requests.management.shop.bestSellingItems(shopId)}?page=${values.page}&paginate=${values.paginate}&${
        values.start_date && `start_date=${values.start_date}&`
      }${values.end_date && `end_date=${values.end_date}`}`
    );
    return response;
  } catch (e) {
    return e.response;
  }
};

const shopBestSellingItemsExcel = async (shopId, values) => {
  try {
    const response = await axios.get(
      `${requests.management.shop.shopBestSellingItemsExcel(shopId)}?page=${values.page}&paginate=${values.paginate}&${
        values.start_date && `start_date=${values.start_date}&`
      }${values.end_date && `end_date=${values.end_date}&`}`,
      {
        responseType: 'blob',
      }
    );
    return response;
  } catch (e) {
    return e.response;
  }
};

const sendSmsShop = async (shopId, values) => {
  try {
    const response = await axios.post(requests.management.shop.sendSms(shopId), values);
    return response;
  } catch (e) {
    return e.response;
  }
};

export {
  getShopById,
  createShop,
  setShopWage,
  editShop,
  editShopHeader,
  editShopLogo,
  editShopAddress,
  syncShopCallNumbers,
  syncShopCategories,
  syncShopMealTags,
  getShopGeofence,
  deleteShopGeofence,
  viewShopGeofence,
  getAllShops,
  getAllShopUsers,
  getShopTransaction,
  shopLiteSearch,
  shopNoticeCallNumbers,
  shopUsersCallNumbers,
  syncNoticeCallNumbers,
  getCheckoutCallNumbers,
  syncCheckoutCallNumbers,
  usersBankAccounts,
  bankAccounts,
  addBankAccount,
  reviewedByShop,
  shopInvioce,
  orderListShopInvoice,
  acceptStatus,
  deleteShopRole,
  getAllShopRoles,
  showShopInvoice,
  shopDiscountCourier,
  getshopDiscountCourier,
  changeGeofenceActiveState,
  changeShopStatus,
  AnnouncingClosureShop,
  isHolidyOpen,
  shopViewOne,
  getShopUserBlock,
  blockUser,
  unBlockShopUser,
  shopSearch,
  syncShopSettlementCategories,
  shopWage,
  setWage,
  getDiscountShop,
  setDiscountShop,
  allShopDiscountCode,
  deleteDiscountCodeShop,
  createDiscountCodeShop,
  ShopMassGroupEdit,
  deleteAddressShop,
  createAddressShop,
  deleteShopUser,
  shopInvioceExcel,
  sendPanelLinkViaSms,
  getCourierSelect,
  syncCouriers,
  deleteShop,
  getClosureShops,
  bestSellingItemsShop,
  shopBestSellingItemsExcel,
  sendSmsShop,
  shopDiscountCourierFee,
};
